import { VolumeViewport } from '../RenderingEngine';
import cache from '../cache/cache';
function getViewportImageIds(viewport) {
    if (viewport instanceof VolumeViewport) {
        const volume = cache.getVolume(viewport.getVolumeId());
        return volume.imageIds;
    }
    else if (viewport.getImageIds) {
        return viewport.getImageIds();
    }
}
export default getViewportImageIds;
